import { useEffect, useState } from 'react';

export const useWelcomeMessage = () => {
  const [welcomeMessage, setWelcomeMessage] = useState(['', '']);

  const getHello = () => {
    let name = JSON.parse(localStorage.getItem('profile')).fname;
    let hiArray = [
      'Hello',
      'Hi',
      'Hi there',
      'Greetings',
      'Welcome back',
      "What's up",
      'Hey',
      'Good to see you',
    ];

    let questionArray = [
      "Here's where AI meets imagination – Let's create something amazing together!",
      'Ready to elevate your ideas with AI-powered productivity?',
      'Your next big idea starts here - Straico is here to help!',
      "Let's turn your thoughts into action!",
      'Ready to outshine? Strike up a chat and let your AI assistant do the rest',
      'What are you willing to explore with multimodal AI today?',
    ];

    // Generate random indices for greetings and questions
    const randomHiIndex = Math.floor(Math.random() * hiArray.length);
    const randomQuestionIndex = Math.floor(
      Math.random() * questionArray.length
    );

    // Get random greeting and question
    const randomHi = hiArray[randomHiIndex];
    const randomQuestion = questionArray[randomQuestionIndex];

    // Concatenate the greeting with the name
    const greetingWithUsername = `${randomHi}, ${name}`;

    // Return both values
    return [greetingWithUsername, randomQuestion];
  };

  useEffect(() => {
    (async () => {
      setWelcomeMessage(getHello());
    })();
  }, []);

  return { welcomeMessage };
};
